import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './DefaultErrorRenderer.module.scss'

export const DefaultErrorRenderer =
  ({ error = '', errorClassName, showErrorText = true }) =>
  () =>
    error && showErrorText && <div className={classNames(errorClassName, styles.error)}>{error}</div>

DefaultErrorRenderer.propTypes = {
  error: PropTypes.string,
  errorClassName: PropTypes.string,
  showErrorText: PropTypes.bool,
}
